import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import { ReduxDispatch } from "../../models/ReduxProps";
import ActionUtility from "../../utilities/ActionUtility";
import DashboardSimulazioneFormModel from "./models/DashboardSimulazioneFormModel";
import ProdottoLightModel from "./models/ProdottoLightModel";
import RichiestaCedibileModel from "./models/RichiestaCedibileModel";
import SimulazioneLightModel from "./models/SimulazioneLightModel";
import SimulazioneModel from "./models/SimulazioneModel";
import SimulazioneExtendedModel from "./models/SimulazioneExtendedModel";
import SimulazioneStepOneCollapseModel from "./models/SimulazioneStepOneCollapseModel";
import SimulazioneStepOneFormModel from "./models/SimulazioneStepOneFormModel";
import SimulazioneStepTwoFormModel from "./models/SimulazioneStepTwoFormModel";
import Simulazione, {
    IAssicurazioniGetRequest,
    ICreditoNetRequest,
    IRicalcolaRequest,
    IRichiestaCedibilitaRequest,
    ISalvaSimulazioneRequest,
    ISimulateRequest,
    ITaegTegRequest,
} from "./SimulazioneEffect";
import AssicurazioneModel from "./models/AssicurazioneModel";
import TaegTegModel from "./models/TaegTegModel";
import SimulazioneStepThreeFormModel from "./models/SimulazioneStepThreeFormModel";
import ProvvigioniComissioniFormModel from "./models/ProvvigioniComissioniFormModel";
import TanBaseFormModel from "./models/TanBaseFormModel";
import OneriFormModel from "./models/OneriFormModel";
import SpeseIstruttoriaFormModel from "./models/SpeseIstruttoriaFormModel";
import SimulazioneCreditoNetFormModel from "./models/SimulazioneCreditoNetFormModel";
import SimulazioneCreditoNetTableModel from "./models/SimulazioneCreditoNetTableModel";
import DettaglioCreditoNetModel from "./models/creditoNet/DettaglioCreditoNetModel";
import SimulazioneRichiestaCedibilitaTableModel from "./models/SimulazioneRichiestaCedibilitaTableModel";
import DettaglioRichiestaCedibilitaModel from "./models/richiestaCedibilita/DettaglioRichiestaCedibilitaModel";
import CommissioniBancaSegnalanteFormModel from "./models/CommissioniBancaSegnalanteFormModel";
import VersionSpendingReviewModel from "./models/VersionSpendingReviewModel";
import { number } from "yup";
import MailCertificataModel from "./models/MailCertificataModel";

type ActionUnion =
    | undefined
    | HttpErrorResponseModel
    | SimulazioneLightModel[]
    | ProdottoLightModel[]
    | AssicurazioneModel[]
    | SimulazioneModel
    | TaegTegModel
    | SimulazioneCreditoNetFormModel
    | SimulazioneCreditoNetTableModel
    | DettaglioCreditoNetModel
    | SimulazioneRichiestaCedibilitaTableModel
    | DettaglioRichiestaCedibilitaModel
    | VersionSpendingReviewModel
    | Number
    | boolean
    | MailCertificataModel;

export default class SimulazioneAction {
    public static readonly REQUEST_SIMULAZIONE_SIMULAZIONI_LIST_GET: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_SIMULAZIONI_LIST_GET";
    public static readonly REQUEST_SIMULAZIONE_SIMULAZIONI_LIST_GET_FINISHED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_SIMULAZIONI_LIST_GET_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_STEP_SET: string = "SimulazioneAction.REQUEST_SIMULAZIONE_STEP_SET";
    public static readonly REQUEST_SIMULAZIONE_STEP_SET_FINISHED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_STEP_SET_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_FORM_DASHBOARD_SET: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_FORM_DASHBOARD_SET";
    public static readonly REQUEST_SIMULAZIONE_FORM_DASHBOARD_SET_FINISHED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_FORM_DASHBOARD_SET_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_FORM_STEP_ONE_SET: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_FORM_STEP_ONE_SET";
    public static readonly REQUEST_SIMULAZIONE_FORM_STEP_ONE_SET_FINISHED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_FORM_STEP_ONE_SET_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_COLLAPSE_STEP_ONE_SET: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_COLLAPSE_STEP_ONE_SET";
    public static readonly REQUEST_SIMULAZIONE_COLLAPSE_STEP_ONE_SET_FINISHED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_COLLAPSE_STEP_ONE_SET_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_RESET_DATI: string = "SimulazioneAction.REQUEST_SIMULAZIONE_RESET_DATI";
    public static readonly REQUEST_SIMULAZIONE_RESET_DATI_FINISHED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_RESET_DATI_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_SET_PRODOTTO_SELECTED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_SET_PRODOTTO_SELECTED";
    public static readonly REQUEST_SIMULAZIONE_SET_PRODOTTO_SELECTED_FINISHED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_SET_PRODOTTO_SELECTED_FINISHED";
    public static readonly REQUEST_SIMULAZIONE_SET_PRODOTTO: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_SET_PRODOTTO";
    public static readonly REQUEST_SIMULAZIONE_SET_ASSICURAZIONE_SELECTED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_SET_ASSICURAZIONE_SELECTED";
    public static readonly REQUEST_SIMULAZIONE_SET_ASSICURAZIONE_SELECTED_FINISHED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_SET_ASSICURAZIONE_SELECTED_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_FORM_STEP_TWO_SET: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_FORM_STEP_TWO_SET";
    public static readonly REQUEST_SIMULAZIONE_FORM_STEP_TWO_SET_FINISHED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_FORM_STEP_TWO_SET_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_RICHIESTA_CEDIBILE_FORM_SET: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_RICHIESTA_CEDIBILE_FORM_SET";
    public static readonly REQUEST_SIMULAZIONE_RICHIESTA_CEDIBILE_FORM_SET_FINISHED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_RICHIESTA_CEDIBILE_FORM_SET_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_FORM_CREDITO_NET: string =
        "SimuazionAction.REQUEST_SIMULAZIONE_FORM_CREDITO_NET";
    public static readonly REQUEST_SIMULAZIONE_FORM_CREDITO_NET_FINISHED: string =
        "SimuazionAction.REQUEST_SIMULAZIONE_FORM_CREDITO_NET_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_SIMULATE: string = "SimulazioneAction.REQUEST_SIMULAZIONE_SIMULATE";
    public static readonly REQUEST_SIMULAZIONE_SIMULATE_FINISHED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_SIMULATE_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_PRODOTTI_LIGHT_GET: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_PRODOTTI_LIGHT_GET";
    public static readonly REQUEST_SIMULAZIONE_PRODOTTI_LIGHT_GET_FINISHED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_PRODOTTI_LIGHT_GET_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_ASSICURAZIONI_GET: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_ASSICURAZIONI_GET";
    public static readonly REQUEST_SIMULAZIONE_ASSICURAZIONI_GET_FINISHED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_ASSICURAZIONI_GET_FINISHED";

    public static readonly SIMULAZIONE_RESET_PRODOTTI: string = "SimulazioneAction.SIMULAZIONE_RESET_PRODOTTI";
    public static readonly SIMULAZIONE_SET_STEP: string = "SimulazioneAction.SIMULAZIONE_SET_STEP";
    public static readonly SIMULAZIONE_RESET_ASSICURAZIONI: string =
        "SimulazioneAction.SIMULAZIONE_RESET_ASSICURAZIONI";

    public static readonly REQUEST_SIMULAZIONE_CALCULATE_TAEG_TEG: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_CALCULATE_TAEG_TEG";
    public static readonly REQUEST_SIMULAZIONE_CALCULATE_TAEG_TEG_FINISHED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_CALCULATE_TAEG_TEG_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_SALVA: string = "SimulazioneAction.REQUEST_SIMULAZIONE_SALVA";
    public static readonly REQUEST_SIMULAZIONE_SALVA_FINISHED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_SALVA_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_FORM_STEP_THREE_SET: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_FORM_STEP_THREE_SET";
    public static readonly REQUEST_SIMULAZIONE_FORM_STEP_THREE_SET_FINISHED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_FORM_STEP_THREE_SET_FINISHED";

    public static readonly SIMULAZIONE_SET_FORM_PROVVIGIONI_COMISSIONI: string =
        "SimulazioneAction.SIMULAZIONE_SET_FORM_PROVVIGIONI_COMISSIONI";

    public static readonly SIMULAZIONE_SET_FORM_TAN_BASE: string = "SimulazioneAction.SIMULAZIONE_SET_FORM_TAN_BASE";

    public static readonly SIMULAZIONE_SET_FORM_ONERI: string = "SimulazioneAction.SIMULAZIONE_SET_FORM_ONERI";

    public static readonly SIMULAZIONE_SET_FORM_SPESE_ISTRUTTORIA: string =
        "SimulazioneAction.SIMULAZIONE_SET_FORM_SPESE_ISTRUTTORIA";

    public static readonly REQUEST_SIMULAZIONE_RICALCOLA: string = "SimulazioneAction.REQUEST_SIMULAZIONE_RICALCOLA";
    public static readonly REQUEST_SIMULAZIONE_RICALCOLA_FINISHED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_RICALCOLA_FINISHED";

    public static readonly SIMULAZIONE_SET_AVVISO_POPUP: string = "SimulazioneAction.SIMULAZIONE_SET_AVVISO_POPUP";

    public static readonly REQUEST_SIMULAZIONE_SET_MAIL_MANDATORY: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_SET_MAIL_MANDATORY";

    public static readonly REQUEST_SIMULAZIONE_SET_ESTIMATE_DATA_MANDATORY: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_SET_ESTIMATE_DATA_MANDATORY";

    public static readonly REQUEST_SIMULAZIONE_TABELLA_CREDITO_NET: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_TABELLA_CREDITO_NET";
    public static readonly REQUEST_SIMULAZIONE_TABELLA_CREDITO_NET_FINISHED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_TABELLA_CREDITO_NET_FINISHED";
    public static readonly REQUEST_SIMULAZIONE_TABELLA_CREDITO_NET_RESET: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_TABELLA_CREDITO_NET_RESET";

    public static readonly REQUEST_SIMULAZIONE_DETTAGLIO_CREDITO_NET: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_DETTAGLIO_CREDITO_NET";
    public static readonly REQUEST_SIMULAZIONE_DETTAGLIO_CREDITO_NET_FINISHED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_DETTAGLIO_CREDITO_NET_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_RICHIESTA_CEDIBILITA_GET: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_RICHIESTA_CEDIBILITA_GET";
    public static readonly REQUEST_SIMULAZIONE_RICHIESTA_CEDIBILITA_GET_FINISHED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_RICHIESTA_CEDIBILITA_GET_FINISHED";
    public static readonly REQUEST_SIMULAZIONE_RICHIESTA_CEDIBILITA_GET_RESET: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_RICHIESTA_CEDIBILITA_GET_RESET";

    public static readonly REQUEST_SIMULAZIONE_DETTAGLIO_RICHIESTA_CEDIBILITA_GET: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_DETTAGLIO_RICHIESTA_CEDIBILITA_GET";
    public static readonly REQUEST_SIMULAZIONE_DETTAGLIO_RICHIESTA_CEDIBILITA_GET_FINISHED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_DETTAGLIO_RICHIESTA_CEDIBILITA_GET_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_UPDATE: string = "SimulazioneAction.REQUEST_SIMULAZIONE_UPDATE";
    public static readonly REQUEST_SIMULAZIONE_UPDATE_FINISHED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_UPDATE_FINISHED";

    public static readonly SIMULAZIONE_SET_SIMULAZIONE_SALVATA: string =
        "SimulazioneAction.SIMULAZIONE_SET_SIMULAZIONE_SALVATA";

    public static readonly REQUEST_SIMULAZIONE_SET_BIRTH_PLACE_MANDATORY: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_SET_BIRTH_PLACE_MANDATORY";

    public static readonly REQUEST_SIMULAZIONE_SET_BIRTH_FOREIGN_PLACE_MANDATORY: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_SET_BIRTH_FOREIGN_PLACE_MANDATORY";

    public static readonly REQUEST_SIMULAZIONE_SET_BIRTH_COUNTY_MANDATORY: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_SET_BIRTH_COUNTY_MANDATORY";

    public static readonly REQUEST_SIMULAZIONE_RESUME: string = "SimulazioneAction.REQUEST_SIMULAZIONE_RESUME";
    public static readonly REQUEST_SIMULAZIONE_RESUME_FINISHED: string =
        "SimulazioneAction.REQUEST_SIMULAZIONE_RESUME_FINISHED";

    public static readonly REQUEST_SPENDING_REVIEW: string = "SimulazioneAction.REQUEST_SPENDING_REVIEW";
    public static readonly REQUEST_SPENDING_REVIEW_FINISHED: string =
        "SimulazioneAction.REQUEST_SPENDING_REVIEW_FINISHED";

    public static readonly SIMULAZIONE_SET_FORM_COMISSIONI_BANCA_SEGNALANTE: string =
        "SimulazioneAction.SIMULAZIONE_SET_FORM_COMISSIONI_BANCA_SEGNALANTE";

    public static readonly REQUEST_CERTIFICA_MAIL_SET: string = "SimulazioneAction.REQUEST_CERTIFICA_MAIL_SET";
    public static readonly REQUEST_CERTIFICA_MAIL_SET_FINISHED: string =
        "SimulazioneAction.REQUEST_CERTIFICA_MAIL_SET_FINISHED";
    public static readonly REQUEST_CERTIFICA_MAIL_VALIDA_SET: string =
        "SimulazioneAction.REQUEST_CERTIFICA_MAIL_VALIDA_SET";
    public static readonly REQUEST_CERTIFICA_MAIL_VALIDA_SET_FINISHED: string =
        "SimulazioneAction.REQUEST_CERTIFICA_MAIL_VALIDA_SET_FINISHED";
    public static readonly RESUME_CERTIFICA_MAIL_SET: string = "SimulazioneAction.RESUME_CERTIFICA_MAIL_SET";
    public static readonly RESUME_CERTIFICA_MAIL_SET_FINISHED: string =
        "SimulazioneAction.RESUME_CERTIFICA_MAIL_SET_FINISHED";
    public static readonly RESET_CERTIFICA_MAIL_SET: string = "SimulazioneAction.RESET_CERTIFICA_MAIL_SET";
    public static readonly RESET_CERTIFICA_MAIL_SET_FINISHED: string =
        "SimulazioneAction.RESET_CERTIFICA_MAIL_SET_FINISHED";
    public static simulazioniGet(total: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<SimulazioneLightModel[]>(
                dispatch,
                SimulazioneAction.REQUEST_SIMULAZIONE_SIMULAZIONI_LIST_GET,
                Simulazione.simulazioniGet,
                total
            );
        };
    }

    public static setStep(step: number): any {
        return ActionUtility.createAction(SimulazioneAction.REQUEST_SIMULAZIONE_STEP_SET_FINISHED, step);
    }

    public static setDashboardForm(dashboardForm: DashboardSimulazioneFormModel) {
        return ActionUtility.createAction(
            SimulazioneAction.REQUEST_SIMULAZIONE_FORM_DASHBOARD_SET_FINISHED,
            dashboardForm
        );
    }

    public static setFormStep1(form: SimulazioneStepOneFormModel): any {
        return ActionUtility.createAction(SimulazioneAction.REQUEST_SIMULAZIONE_FORM_STEP_ONE_SET_FINISHED, form);
    }

    public static setFormStep2(form: SimulazioneStepTwoFormModel): any {
        return ActionUtility.createAction(SimulazioneAction.REQUEST_SIMULAZIONE_FORM_STEP_TWO_SET_FINISHED, form);
    }

    public static setCollapseStep1(collapse: SimulazioneStepOneCollapseModel): any {
        return ActionUtility.createAction(
            SimulazioneAction.REQUEST_SIMULAZIONE_COLLAPSE_STEP_ONE_SET_FINISHED,
            collapse
        );
    }

    public static resetDati(): any {
        return ActionUtility.createAction(SimulazioneAction.REQUEST_SIMULAZIONE_RESET_DATI_FINISHED);
    }

    public static setProdottoSelected(prodotto: SimulazioneExtendedModel): any {
        return ActionUtility.createAction(
            SimulazioneAction.REQUEST_SIMULAZIONE_SET_PRODOTTO_SELECTED_FINISHED,
            prodotto
        );
    }

    public static setAssicurazioneSelected(assicurazione: AssicurazioneModel): any {
        return ActionUtility.createAction(
            SimulazioneAction.REQUEST_SIMULAZIONE_SET_ASSICURAZIONE_SELECTED_FINISHED,
            assicurazione
        );
    }

    public static setRichiestaCedibileForm(form: RichiestaCedibileModel): any {
        return ActionUtility.createAction(
            SimulazioneAction.REQUEST_SIMULAZIONE_RICHIESTA_CEDIBILE_FORM_SET_FINISHED,
            form
        );
    }

    public static simulate(request: ISimulateRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<SimulazioneModel>(
                dispatch,
                SimulazioneAction.REQUEST_SIMULAZIONE_SIMULATE,
                Simulazione.simulate,
                request
            );
        };
    }

    public static prodottiLightGet(
        idRequestedType: number,
        idAdministrativeCategory: number,
        segment: string,
        importo: string,
        durata: string,
        eta: string,
        idAgent?: number,
        dipendenteBanca?: boolean,
        rata?: string
    ): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ProdottoLightModel[]>(
                dispatch,
                SimulazioneAction.REQUEST_SIMULAZIONE_PRODOTTI_LIGHT_GET,
                Simulazione.prodottiLightGet,
                idRequestedType,
                idAdministrativeCategory,
                segment,
                importo,
                durata,
                eta,
                idAgent,
                dipendenteBanca,
                rata
            );
        };
    }

    public static assicurazioniGet(request: IAssicurazioniGetRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<AssicurazioneModel[]>(
                dispatch,
                SimulazioneAction.REQUEST_SIMULAZIONE_ASSICURAZIONI_GET,
                Simulazione.assicurazioniGet,
                request
            );
        };
    }

    public static resetProdotti(stepDiProvenienza: string | undefined): any {
        return ActionUtility.createAction(SimulazioneAction.SIMULAZIONE_RESET_PRODOTTI, stepDiProvenienza);
    }

    public static setStepProvenienza(stepDiProvenienza: string | undefined): any {
        return ActionUtility.createAction(SimulazioneAction.SIMULAZIONE_SET_STEP, stepDiProvenienza);
    }

    public static resetAssicurazioni(): any {
        return ActionUtility.createAction(SimulazioneAction.SIMULAZIONE_RESET_ASSICURAZIONI);
    }

    public static calculateTaegTeg(request: ITaegTegRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<TaegTegModel>(
                dispatch,
                SimulazioneAction.REQUEST_SIMULAZIONE_CALCULATE_TAEG_TEG,
                Simulazione.calculateTaegTeg,
                request
            );
        };
    }

    public static salva(request: ISalvaSimulazioneRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<SimulazioneModel>(
                dispatch,
                SimulazioneAction.REQUEST_SIMULAZIONE_SALVA,
                Simulazione.salva,
                request
            );
        };
    }

    public static update(request: ISalvaSimulazioneRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<SimulazioneModel>(
                dispatch,
                SimulazioneAction.REQUEST_SIMULAZIONE_UPDATE,
                Simulazione.update,
                request
            );
        };
    }

    public static setFormStep3(form: SimulazioneStepThreeFormModel): any {
        return ActionUtility.createAction(SimulazioneAction.REQUEST_SIMULAZIONE_FORM_STEP_THREE_SET_FINISHED, form);
    }

    public static setFormProvvigioniComissioni(form: ProvvigioniComissioniFormModel): any {
        return ActionUtility.createAction(SimulazioneAction.SIMULAZIONE_SET_FORM_PROVVIGIONI_COMISSIONI, form);
    }

    public static setFormTanBase(form: TanBaseFormModel): any {
        return ActionUtility.createAction(SimulazioneAction.SIMULAZIONE_SET_FORM_TAN_BASE, form);
    }

    public static setFormOneri(form: OneriFormModel): any {
        return ActionUtility.createAction(SimulazioneAction.SIMULAZIONE_SET_FORM_ONERI, form);
    }

    public static setFormSpeseIstruttoria(form: SpeseIstruttoriaFormModel): any {
        return ActionUtility.createAction(SimulazioneAction.SIMULAZIONE_SET_FORM_SPESE_ISTRUTTORIA, form);
    }

    public static ricalcola(request: IRicalcolaRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<SimulazioneModel>(
                dispatch,
                SimulazioneAction.REQUEST_SIMULAZIONE_RICALCOLA,
                Simulazione.ricalcola,
                request
            );
        };
    }

    public static setAvvisoPopup(open: boolean): any {
        return ActionUtility.createAction(SimulazioneAction.SIMULAZIONE_SET_AVVISO_POPUP, open);
    }

    public static setMailMandatory(setMandatory: boolean): any {
        return ActionUtility.createAction(SimulazioneAction.REQUEST_SIMULAZIONE_SET_MAIL_MANDATORY, setMandatory);
    }

    public static setEsitamateDataMandatory(setMandatory: boolean): any {
        return ActionUtility.createAction(
            SimulazioneAction.REQUEST_SIMULAZIONE_SET_ESTIMATE_DATA_MANDATORY,
            setMandatory
        );
    }

    public static setFormCreditoNet(form: SimulazioneCreditoNetFormModel): any {
        return ActionUtility.createAction(SimulazioneAction.REQUEST_SIMULAZIONE_FORM_CREDITO_NET_FINISHED, form);
    }

    public static creditoNetGet(request: ICreditoNetRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<SimulazioneCreditoNetTableModel>(
                dispatch,
                SimulazioneAction.REQUEST_SIMULAZIONE_TABELLA_CREDITO_NET,
                Simulazione.creditoNetGet,
                request
            );
        };
    }

    public static setCreditoNetTable(model: SimulazioneCreditoNetTableModel[]): any {
        return ActionUtility.createAction(SimulazioneAction.REQUEST_SIMULAZIONE_TABELLA_CREDITO_NET_FINISHED, model);
    }

    public static resetCreditoNet(): any {
        return ActionUtility.createAction(SimulazioneAction.REQUEST_SIMULAZIONE_TABELLA_CREDITO_NET_RESET);
    }

    public static dettaglioCreditoNetGet(id: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<DettaglioCreditoNetModel>(
                dispatch,
                SimulazioneAction.REQUEST_SIMULAZIONE_DETTAGLIO_CREDITO_NET,
                Simulazione.dettaglioCreditoNetGet,
                id
            );
        };
    }

    public static richiestaCedibilitaGet(request: IRichiestaCedibilitaRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<SimulazioneRichiestaCedibilitaTableModel>(
                dispatch,
                SimulazioneAction.REQUEST_SIMULAZIONE_RICHIESTA_CEDIBILITA_GET,
                Simulazione.richiestaCedibilitaGet,
                request
            );
        };
    }

    public static setRichiestaCedibilitaTable(model: SimulazioneRichiestaCedibilitaTableModel[]): any {
        return ActionUtility.createAction(
            SimulazioneAction.REQUEST_SIMULAZIONE_RICHIESTA_CEDIBILITA_GET_FINISHED,
            model
        );
    }

    public static dettaglioRichiestaCedibilitaGet(id: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<DettaglioRichiestaCedibilitaModel>(
                dispatch,
                SimulazioneAction.REQUEST_SIMULAZIONE_DETTAGLIO_RICHIESTA_CEDIBILITA_GET,
                Simulazione.dettaglioRichiestaCedibilitaGet,
                id
            );
        };
    }

    public static resetRichiestaCedibilita(): any {
        return ActionUtility.createAction(SimulazioneAction.REQUEST_SIMULAZIONE_RICHIESTA_CEDIBILITA_GET_RESET);
    }

    public static setSimulazioneSalvata(simulazione: SimulazioneModel): any {
        return ActionUtility.createAction(SimulazioneAction.SIMULAZIONE_SET_SIMULAZIONE_SALVATA, simulazione);
    }

    public static setBirthPlaceMandatory(setMandatory: boolean): any {
        return ActionUtility.createAction(
            SimulazioneAction.REQUEST_SIMULAZIONE_SET_BIRTH_PLACE_MANDATORY,
            setMandatory
        );
    }

    public static setBirthForeignPlaceMandatory(setMandatory: boolean): any {
        return ActionUtility.createAction(
            SimulazioneAction.REQUEST_SIMULAZIONE_SET_BIRTH_FOREIGN_PLACE_MANDATORY,
            setMandatory
        );
    }

    public static setBirthCountyMandatory(setMandatory: boolean): any {
        return ActionUtility.createAction(
            SimulazioneAction.REQUEST_SIMULAZIONE_SET_BIRTH_COUNTY_MANDATORY,
            setMandatory
        );
    }

    public static resumeSimulation(idSimulation: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<SimulazioneModel>(
                dispatch,
                SimulazioneAction.REQUEST_SIMULAZIONE_RESUME,
                Simulazione.resumeSimulation,
                idSimulation
            );
        };
    }

    public static setFormCommissioniBancaSegnalante(form: CommissioniBancaSegnalanteFormModel): any {
        return ActionUtility.createAction(SimulazioneAction.SIMULAZIONE_SET_FORM_COMISSIONI_BANCA_SEGNALANTE, form);
    }

    public static getSpendingReview(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<VersionSpendingReviewModel>(
                dispatch,
                SimulazioneAction.REQUEST_SPENDING_REVIEW,
                Simulazione.getSpendingReview
            );
        };
    }

    public static setCertificaEmail(email: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<Number>(
                dispatch,
                SimulazioneAction.REQUEST_CERTIFICA_MAIL_SET,
                Simulazione.setCertificaMail,
                email
            );
        };
    }

    public static setValidaEmail(email: string, idCertificazione: Number, otp: string, IdSimulation: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<boolean>(
                dispatch,
                SimulazioneAction.REQUEST_CERTIFICA_MAIL_VALIDA_SET,
                Simulazione.setValidaMail,
                email,
                idCertificazione,
                otp,
                IdSimulation
            );
        };
    }

    public static resumeCertificateMail(email: string, idCertificazione: Number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<MailCertificataModel>(
                dispatch,
                SimulazioneAction.RESUME_CERTIFICA_MAIL_SET,
                Simulazione.resumeCertificateMail,
                email,
                idCertificazione
            );
        };
    }
    public static resetCertificateMail(): any {
        return ActionUtility.createAction(SimulazioneAction.RESET_CERTIFICA_MAIL_SET);
    }
}

//TODO: finish the reducer
